// eslint-disable-next-line no-restricted-imports
import { Search as DSSearch } from "@packages/ds";

// Only export TrackedSearch as the main Search component
export { TrackedSearch as Search } from "./TrackedSearch";
export { TrackedSearch } from "./TrackedSearch";

// Export subcomponents for backward compatibility (but still force analytics usage)
// These will be the DS subcomponents but accessed through console wrapper
export const Icon = DSSearch.Icon;
export const Close = DSSearch.Close;
export const Root = DSSearch.Root;

// Export the input component as SearchPrimitive for backward compatibility
export const SearchPrimitive = DSSearch.Input;

// Export types for convenience
export type { SearchProps } from "@packages/ds";

// Default export points to TrackedSearch
export { TrackedSearch as default } from "./TrackedSearch";
